/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    DASHBOARD_PROFILE_BOXES
 * Date:         2025-12-27
 * Modified By:  Cursor
 *
 * Description:
 * Implemented 3 dashboard profile/status boxes showing Personal Profile completion,
 * Company Profile completion, and Inventory Status. Boxes appear between the search
 * banner and broadcasts list with responsive grid layout.
 *
 * Related Screens / Modules:
 * - client/src/features/dashboard/DashboardProfileBoxes.tsx
 * - client/src/features/dashboard/PersonalProfileBox.tsx
 * - client/src/features/dashboard/CompanyProfileBox.tsx
 * - client/src/features/dashboard/InventoryStatusBox.tsx
 * - client/src/pages/Dashboard.tsx
 * - client/src/style/_components.scss
 */

import React from "react";
import PersonalProfileBox from "./PersonalProfileBox";
import CompanyProfileBox from "./CompanyProfileBox";
import InventoryStatusBox from "./InventoryStatusBox";

// [2025-12-27] Profile boxes: Responsive container for 3 status boxes
const DashboardProfileBoxes: React.FC = () => {
  return (
    <section className="my-4">
      <div className="dashboard-profile-boxes">
        <PersonalProfileBox />
        <CompanyProfileBox />
        <InventoryStatusBox />
      </div>
    </section>
  );
};

export default DashboardProfileBoxes;
